import { ProductCategory, PRODUCT_CATEGORIES } from './pricing';

export const CATEGORY_TILES = PRODUCT_CATEGORIES;

const SLUG_BY_CATEGORY: Record<ProductCategory, string> = {
  [ProductCategory.Tools]: 'tools',
  [ProductCategory.Electronics]: 'electronics',
  [ProductCategory.FilmAndPhotography]: 'film-and-photography',
  [ProductCategory.Home]: 'home',
  [ProductCategory.Party]: 'party',
  [ProductCategory.Sport]: 'sport',
  [ProductCategory.Other]: 'other',
};

const CATEGORY_BY_SLUG = Object.fromEntries(
  Object.entries(SLUG_BY_CATEGORY).map(([category, slug]) => [slug, Number(category) as ProductCategory]),
) as Record<string, ProductCategory>;

export const categoryImageSrc = (category: ProductCategory): string => {
  switch (category) {
    case ProductCategory.Tools: return '/images/drill.png';
    case ProductCategory.Electronics: return '/images/laptop.png';
    case ProductCategory.FilmAndPhotography: return '/images/camera.png';
    case ProductCategory.Home: return '/images/sewing-machine.png';
    case ProductCategory.Party: return '/images/grill.png';
    case ProductCategory.Sport: return '/images/rackets.png';
    case ProductCategory.Other: return '/images/cat.png';
    default: return '/images/box.png';
  }
};

export const categoryLabelKey = (category: ProductCategory): string => {
  switch (category) {
    case ProductCategory.Tools: return 'manage.category_tools';
    case ProductCategory.Electronics: return 'manage.category_electronics';
    case ProductCategory.FilmAndPhotography: return 'manage.category_film';
    case ProductCategory.Home: return 'manage.category_home';
    case ProductCategory.Party: return 'manage.category_party';
    case ProductCategory.Sport: return 'manage.category_sport';
    default: return 'manage.category_other';
  }
};

export const categorySlug = (category: ProductCategory): string =>
  SLUG_BY_CATEGORY[category] ?? SLUG_BY_CATEGORY[ProductCategory.Other];

export const hasCategoryFilter = (category: ProductCategory | null | undefined): boolean =>
  category != null;

export const categoryFromSlug = (slug: string | undefined): ProductCategory | null => {
  if (!slug) return null;
  return CATEGORY_BY_SLUG[slug] ?? null;
};
